import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Auto_ProductRef from '../StoreRoomReciept/Auto_ProductRef';
// import Auto_Ref from '../StoreRoomReciept/Auto_Ref';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";


const InsertFirstPeriodRecieptIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    // const RefRef = useRef()
    const ProductRef = useRef()
    // const GetTaxRef = useRef()
    const StoreRef = useRef()
    const [ItemList, setItemList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("RecieptHeaderId"));
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Code, setCode] = useState("");

    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [Type, setType] = useState(0);
    const [RemainCount, setRemainCount] = useState(0);
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [SumItemPrice, setSumItemPrice] = useState(0);
    const [InsertDate, setInsertDate] = useState(moment(new Date())); // moment((new Date).format("jYYYY/jMM/jDD"))
    const [ReadOnlyInsertDate, setReadOnlyInsertDate] = useState("");


    //#endregion





    const InsertDate_Change = e => {
        setItemList([]);
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setInsertDate(moment(m, 'jYYYY/jMM/jDD'));


    }


    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReciept/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': HeaderId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(moment(result.insertDate, 'jYYYY/jMM/jDD'))
                    setReadOnlyInsertDate(result.insertDate)
                    setType(result.type);
                    setHeaderPrice(result.price);
                    setStoreRoomId(result.storeRoomId);
                    setCode(result.code);

                })
        )
    }

    const Reset = () => {
        setItemList([]);
        setHeaderId(General.GuidEmpty());
        setCode("");
        setStoreRoomId(-1);
        setRemainCount(0);
        setHeaderPrice(0);
        setSumItemPrice(0);
        setInsertDate(moment(new Date()));
        setReadOnlyInsertDate("");
    }

    const Save = () => {

        if (StoreRoomId == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب انبار اجباری می باشد")), 'topCenter')
            return;
        }
        if (InsertDate == "" || InsertDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ رسید اجباری می باشد")), 'topCenter')
            return;
        }

        if (ItemList.length == 0 || (ItemList.length == 1 && ItemList[0].status != "EDIT")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست رسید محصول اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": HeaderId,
                "SupplierId": General.GuidEmpty().toString(),
                "Price": HeaderPrice,
                "InsertDate": moment(InsertDate.format()).format('jYYYY/jMM/jDD'),
                "Type": Type,
                "StoreRoomId": StoreRoomId,
                "FiscalYearId": FiscalYearId,
                "FreightPrice": 0,
                "DiscountType": 0,
                "Children": [...ItemList].filter(item => item.ProductId != General.GuidEmpty() && item.status != 'EDIT'),
            },
            url: General.ApiRoute() + "/StoreRoomReciept/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        if (HeaderId == General.GuidEmpty())
                            Reset();
                        else {
                            localStorage.removeItem("RecieptHeaderId");
                            navigate("/FirstPeriodReciept")
                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const onEditItem = (row) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
            temp[index].Price = PN.sliceNumber(temp[index].Price);
            temp[index].TotalPrice = PN.sliceNumber(temp[index].TotalPrice);
        }
        setItemList(temp);
    }

    const NewItem = () => {
        if (StoreRoomId != -1) {
            setItemList([
                ...ItemList,
                {
                    row: ItemList.length + 1,
                    ProductId: General.GuidEmpty(),
                    ProductTitle: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    RefId: General.GuidEmpty(),
                    RefTitle: "",
                    Count: 1,
                    TotalPrice: 0,
                    Price: 0,
                    Tax: 0,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    DiscountType: 0,
                }

            ]);
        }
        else
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انبار را انتخاب کنید")), 'topCenter')

    }
    const Change_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);

        if (index != -1) {

            var price = temp[index].Price > '0' ? temp[index].Price.replaceAll(",", "") : 0
            var totalPrice = 0;

            if (dataType == "Price") {
                price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                totalPrice = price * 1 * temp[index].Count * 1;
                temp[index].Price = PN.sliceNumber(price);
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
            }
            else if (dataType == "Count") {
                temp[index].Count = value;
                totalPrice = price * 1 * value * 1;
                temp[index].TotalPrice = PN.sliceNumber(totalPrice);
            }


            else if (dataType == "ProductRef" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].ProductId = value.split("|")[0];
                    temp[index].ProductTitle = value.split("|")[1];
                    temp[index].RemainCount = value.split("|")[2];
                    temp[index].Price = value.split("|")[3] * 1 != 0 ? PN.sliceNumber(value.split("|")[3] * 1) : 0;
                    temp[index].TotalPrice = value.split("|")[3] * 1 != 0 ? PN.sliceNumber(value.split("|")[3] * 1 * temp[index].Count) : 0;
                    return;
                }
                temp[index].ProductTitle = value;
                temp[index].RemainCount = 0;
                temp[index].Price = 0;
                temp[index].TotalPrice = 0;
                ProductRef.current.BindByStoreId(StoreRoomId, value)
            }


        }
        setItemList(temp);
    }

    const Select_Item = (row, dataType, value) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].ProductId = value.split("|")[0];
            temp[index].ProductTitle = value.split("|")[1];
            temp[index].RemainCount = value.split("|")[2];
            temp[index].Price = value.split("|")[3] * 1 != 0 ? PN.sliceNumber(value.split("|")[3] * 1) : 0;
            temp[index].TotalPrice = value.split("|")[3] * 1 != 0 ? PN.sliceNumber(value.split("|")[3] * 1 * temp[index].Count) : 0;

            setItemList(temp);
        }
    }

    const SaveItem = (row) => {


        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].Price == "0" || temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("قیمت محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].Count == "0" || temp[index].Count == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد محصول اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].ProductId == General.GuidEmpty()) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب محصول اجباری می باشد")), 'topCenter')
                return;
            }


            temp[index].status = "";
            temp[index].Price = temp[index].Price != "0" && temp[index].Price != 0 ? temp[index].Price.replaceAll(',', '') * 1 : 0;
            temp[index].TotalPrice = temp[index].TotalPrice != "0" && temp[index].TotalPrice != 0 ? temp[index].TotalPrice.replaceAll(',', '') * 1 : 0;
            setSumItemPrice(temp.map(o => o.Price).reduce((a, b) => a + b) * 1);
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1);
            if (temp.filter(item => item.ProductId == General.GuidEmpty()).length == 0)
                temp.push({
                    row: temp.length + 1,
                    ProductId: General.GuidEmpty(),
                    ProductTitle: '',
                    Editable: true,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    RefId: General.GuidEmpty(),
                    RefTitle: "",
                    Count: 1,
                    TotalPrice: 0,
                    Price: 0,
                    Tax: 0,
                    DiscountPrice: 0,
                    DiscountPercent: 0,
                    DiscountType: 0,
                })


            setItemList(temp);
        }


    }

    const DeleteItem = (row) => {

        var temp = [...ItemList.filter(item => item.row !== row)];
        setItemList(temp);
        if (temp.length > 0) {
            setSumItemPrice(temp.map(o => o.Price).reduce((a, b) => a + b) * 1);
            setHeaderPrice(temp.map(o => o.TotalPrice).reduce((a, b) => a + b) * 1);

        }
        else {
            setSumItemPrice(0);
            setHeaderPrice(0);

        }
        const inputElement = document.querySelector('.FocusBtn');
        if (inputElement) {
            inputElement.focus();
        }


    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 49);
        myHeaders.append("Operation", HeaderId != General.GuidEmpty() ? 3 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("RecieptHeaderId") != undefined && localStorage.getItem("RecieptHeaderId") != General.GuidEmpty())
                            GetById();
                        StoreRef.current.Bind(-1);
                        StoreRef.current.focus();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e) => {

        if (e.key == "Enter") {

            if ([...ItemList].length > 0) {
                var index = [...ItemList].findIndex(x => x.status == "EDIT");
                console.dir(index)
                console.dir(ItemList)
                if (index != -1) {
                    SaveItem([...ItemList][index].row);
                    return;
                }
                else if (StoreRoomId != -1) {
                    NewItem();
                    return;
                }
            }
            else if (StoreRoomId != -1) {
                NewItem();
                return;
            }
        }
        if (e.key == "Delete") {
            var index = [...ItemList].findIndex(x => x.status == "EDIT");
            if (index != -1)
                DeleteItem([...ItemList][index].row);
            else if ([...ItemList].length > 0) {
                var LastItem = [...ItemList].length;
                if (LastItem != 0)
                    DeleteItem([...ItemList][LastItem - 1].row);
            }
        }


        if (e.key == "Escape") {
            navigate("/FirstPeriodReciept")
        }


        if (e.shiftKey && e.code === 'KeyP') {
            localStorage.setItem("BackPage", "FirstPeriodReciept");
            navigate("/PrintReciept")
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = "رسید ابتدای دوره انبار";
    }, [])
    //#endregion







    return (

        <Layout title="ثبت رسید ابتدای انبار">
            <div className="h-100 p-1" onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Save}>  ثبت</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("RecieptHeaderId"), navigate("/FirstPeriodReciept"))}>  بازگشت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                            <label>کد</label>
                            <rsuite.Input disabled value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تاریخ </label>
                            {HeaderId == General.GuidEmpty() ?
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={InsertDate} onChange={InsertDate_Change} />
                                :
                                <rsuite.Input disabled value={ReadOnlyInsertDate} />

                            }
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>انبار</label>
                            <Drp_StoreRoom disabled={HeaderId == General.GuidEmpty() ? false : true} className='rs-input' value={StoreRoomId} onChange={(e) => (setStoreRoomId(e), setItemList([]), setHeaderPrice(0))} ref={StoreRef} />
                        </rsuite.Col>


                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1">
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button appearance="primary" className='FocusBtn' color="green" size='xs'
                                onClick={() => NewItem()}>
                                اضافه شدن مشخصات جدید
                            </rsuite.Button>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={320} data={ItemList} rowHeight={70}>
                                <rsuite.Table.Column width={50} align="center"  >
                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="row">
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={2} fullText resizable>
                                    <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >


                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <Auto_ProductRef className="rs-input" value={rowData.ProductTitle} onChange={value => {
                                                            Change_Item?.(rowData.row, "ProductRef", value);
                                                        }
                                                        }
                                                            onSelect={value => {
                                                                Select_Item?.(rowData.row, "ProductRef", value);
                                                            }} ref={ProductRef} />
                                                        <small>
                                                            موجودی  قابل فروش انبار : {rowData.RemainCount}
                                                        </small>
                                                    </>
                                                ) : (
                                                    <text>

                                                        {rowData.ProductTitle}
                                                        <br />
                                                        <small >
                                                            موجودی  قابل فروش انبار : {rowData.RemainCount}
                                                        </small>
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={100} >
                                    <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell  >
                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (

                                                    <rsuite.Input value={rowData.Count} onChange={value => {
                                                        Change_Item?.(rowData.row, "Count", value);
                                                    }} />

                                                ) : (
                                                    <text>

                                                        {rowData.Count}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={rowData.Price} onChange={value => {
                                                            Change_Item?.(rowData.row, "Price", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.Price)}
                                                        {/* <br/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text> */}

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>


                                <rsuite.Table.Column flexGrow={1} >
                                    <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>
                                                        <rsuite.Input value={rowData.TotalPrice} disabled />
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>
                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.TotalPrice)}
                                                        {/* <br/>
                                                        <rsuite.Text className='Font8 float-start' as='sub'>{rowData.TotalPrice != "0" ? <>{PN.convert(rowData.TotalPrice)} ریال</> : ""}</rsuite.Text> */}

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>



                                <rsuite.Table.Column width={100} fixed='right'>
                                    <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.Editable ?
                                                    !rowData.ForParent ?
                                                        <>

                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                        :
                                                        <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />




                                                    :
                                                    <></>
                                                }
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font17 '>


                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                            <b>قیمت کل : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>

                        </rsuite.Col>


                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن محصول جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+p :</b> پرینت
                            </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >



        </Layout >


    )
}

export default InsertFirstPeriodRecieptIndex;